import { Link, Outlet } from "react-router-dom";
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { useContext } from "react";
import { UserContext } from "..";

const Header = () => {
  const user = useContext(UserContext);

  return (
    <Navbar collapseOnSelect expand="lg" fixed="top" bg="primary" variant="dark">
      <Container fluid>
        <Navbar.Brand as={Link} to={user ? "/aktuality" : "/"}>SVJ381</Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          {user ?
          <Nav className="me-auto">
            <Nav.Link eventKey="1" as={Link} to={"/aktuality"}>Aktuality</Nav.Link>
            <Nav.Link eventKey="2" as={Link} to={"/dokumenty"}>Dokumenty</Nav.Link>
            <Nav.Link eventKey="3" as={Link} to={"/havarijni-sluzby"}>Havarijní služby</Nav.Link>
            <Nav.Link eventKey="4" as={Link} to={"/kontakty"}>Kontakty</Nav.Link>
            <Nav.Link eventKey="5" as={Link} to={"/koutek-dobrych-rad"}>Koutek dobrých rad</Nav.Link>
            {user?.isPowerUser &&
            <Nav.Link eventKey="6" as={Link} to={"/uzivatele"}>Uživatelé</Nav.Link>
            }
            <Nav.Link eventKey="7" as={Link} to={"/zmena-hesla"}>Změna hesla</Nav.Link>
            <Nav.Link eventKey="8" as={Link} to={"/odhlasit"}>Odhlásit</Nav.Link>
          </Nav>
          :
          <Nav className="me-auto">
            <Nav.Link eventKey="1" as={Link} to={"/"}>Portál SVJ Hrdličkova Blatenská</Nav.Link>
          </Nav>
          }
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

const Footer = () => {
  return (
    <>
    </>
  );
}

const Layout = () => {
  return (
    <>
      <Header />
      <div id="content">
        <Outlet />
      </div>
      <Footer />
    </>
  );
};

export default Layout;